import React, { Component } from "react";

class FooterContent extends Component {
    render() {
        const buildTimestamp = "2025-11-19 16:34:20";
        const buildTProductVersion = "8.2.49.202511";
        const linkStyle = { color: "white", textDecoration: "none" };

        return (
            <div className="w-100 d-flex justify-content-center">
                <div
                    className={`text-center ${this.props.useCopyrightClass ? "copyright" : ""}`}
                    style={{ ...this.props.copyright, maxWidth: "100%", margin: "0 auto" }}
                >
                    <div style={{ marginBottom: "0.25rem" }}>
                        <span className="ms-1" style={linkStyle}>
                            Version: ({buildTProductVersion} built at {buildTimestamp})
                        </span>
                    </div>

                    <div style={{ marginTop: "0.25rem" }}>
                        &copy; {new Date().getFullYear()}{" "}
                        <a
                            className="ms-1"
                            href="https://www.knoa.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={linkStyle}
                        >
                            Knoa Software
                        </a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a
                            className="ms-1"
                            href={process.env.REACT_APP_MAUI_DATA_PRIVACY_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={linkStyle}
                        >
                            Data Privacy
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default FooterContent;